import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES, PRODUCTS } from "@/data/products";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Shop() {
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    return PRODUCTS.filter((p) => (cat === "All" || p.category === cat || p.tags?.includes(cat)) && (!q || p.name.toLowerCase().includes(q.toLowerCase())));
  }, [cat, q]);

  return (
    <div data-testid="shop-page">
      <section className="section-y pb-8">
        <div className="container-x">
          <div className="grid lg:grid-cols-2 gap-8 items-end">
            <div>
              <div className="overline">Shop</div>
              <h1 className="font-display text-5xl lg:text-6xl text-sage-800 mt-3 text-balance">Wellness essentials, thoughtfully curated.</h1>
              <p className="mt-5 text-sage-800/70 max-w-md">Professional-grade vitamins, supplements and wellness products — the same ones we use with our own clients.</p>
            </div>
            <div className="relative max-w-md lg:justify-self-end w-full">
              <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-sage-800/50" />
              <Input placeholder="Search products…" value={q} onChange={(e)=>setQ(e.target.value)} className="pl-10 h-12 rounded-full bg-white border-sand-300" data-testid="shop-search" />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          <div className="flex gap-2 flex-wrap mb-8" data-testid="shop-filters">
            {CATEGORIES.map((c) => (
              <button key={c} onClick={()=>setCat(c)} data-testid={`shop-cat-${c.replace(/\s+/g,'-').toLowerCase()}`} className={`btn-pill text-xs px-4 py-2 border transition-colors ${cat===c?"bg-sage-700 text-white border-sage-700":"border-sand-300 text-sage-800 bg-white hover:bg-sand-100"}`}>{c}</button>
            ))}
          </div>

          {list.length === 0 && <div className="text-center py-20 text-sage-800/50">No products match your search.</div>}

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {list.map((p) => (
              <Link key={p.id} to={`/shop/${p.id}`} data-testid={`product-${p.id}`} className="card-lift block rounded-3xl bg-white border border-sand-200/60 overflow-hidden">
                <div className="aspect-square overflow-hidden bg-sand-100">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                <div className="p-5">
                  <div className="text-[10px] uppercase tracking-widest text-clay-600">{p.category}</div>
                  <div className="font-display text-lg text-sage-800 mt-1 line-clamp-1">{p.name}</div>
                  <div className="text-sage-800/60 text-sm mt-1 line-clamp-2">{p.short}</div>
                  <div className="mt-3 flex justify-between items-center">
                    <div className="text-sage-800 font-medium">${p.price}</div>
                    <div className="text-xs text-sage-700 group-hover:underline">View →</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
